export default "__VITE_ASSET__D5i7Er_v__"